import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { FormValues } from "../types";
import { useTranslation } from "react-i18next";
import { useUsersByRoles } from "@/hooks/useUsersByRoles";
import { UserRoleEnum } from "@/__generated__/graphql";

export const useSenderInfo = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "bulkMessaging.composeMessage",
  });
  const { watch } = useFormContext<FormValues>();
  const { data } = useUsersByRoles({
    roles: [UserRoleEnum.Counselor, UserRoleEnum.Influencer],
  });

  const sender = watch("sender");

  const senderInfo = useMemo(() => {
    if (sender?.assignedCounselor) {
      return {
        name: t("assignedCounselor"),
        profilePhoto: null,
      };
    } else if (sender?.userId) {
      const counselor = data?.find((c) => c.id === sender.userId);
      return {
        name: counselor?.name || t("unknownSender"),
        profilePhoto: counselor?.profilePhoto || null,
      };
    }
    return {
      name: undefined,
      profilePhoto: null,
    };
  }, [sender, data, t]);

  return senderInfo;
};
